import React from 'react';
import { Text } from '@mantine/core';
import {
  BUTTON_STYLE_PRESETS,
  buttonStylePatch,
} from '../../../shared/boxes/button/buttonStyles';
import ButtonPreview from './ButtonPreview';
import { useSelectedItemProps } from './useSelectedItemProps';
import ThemeStyleGallery, { CustomStyleTile } from './ThemeStyleGallery';
import StyleCardPreview from '../../theme/StyleCardPreview';
import styles from './ButtonStylePicker.module.css';

/**
 * Galerie de styles de bouton. Un style est un JEU DE VALEURS, pas une
 * variante.
 * Les génériques sont des COPIES : en cliquer un recopie ses valeurs dans le
 * bloc, qui reste « Personnalisé » (aucun n'est jamais surligné). Seul un
 * style du thème se suit (cf. ThemeStyleGallery).
 *
 * Pendant du sélecteur de styles de Carte info
 * (blocks/web/InfoCard/InfoCardStylePicker) et des dispositions de section
 * (SectionLayoutPresetPicker).
 */
export default function ButtonStylePicker({ buttonProps, onPatch }) {
  const selected = useSelectedItemProps();
  // Une slide de carrousel porte son propre bouton : la galerie lit et écrit
  // alors l'item de la liste, pas le bloc sélectionné.
  const itemProps = buttonProps || selected.itemProps;
  const applyPatch = onPatch || selected.updateItemProps;
  // Recopier un générique quitte le style du thème ; le bouton d'une slide
  // n'en suit aucun.
  const copyPatch = (def) => ({
    ...buttonStylePatch(def, itemProps),
    ...(buttonProps ? {} : { themeStyleId: null }),
  });

  const generics = (
    <div className={styles.grid} role="listbox" aria-label="Style du bouton">
      {BUTTON_STYLE_PRESETS.map((def) => (
        <button
          key={def.key}
          type="button"
          role="option"
          aria-selected={false}
          title={def.label}
          className={styles.card}
          // Un seul dispatch : le style pose toutes ses valeurs d'un coup,
          // donc une seule entrée d'historique et un seul patch autosave.
          onClick={() => applyPatch(copyPatch(def))}
        >
          <StyleCardPreview kind="button" values={{ ...def.props, color: itemProps?.color }} />
          <Text size="10px" c="dimmed" lh={1.2} ta="center">
            {def.label}
          </Text>
        </button>
      ))}
      {/* Le bouton d'une slide n'a pas de section « Thème du site » : la
          tuile témoin vient avec les génériques. */}
      {buttonProps && <CustomStyleTile classes={styles} isCustom />}
    </div>
  );

  // Le bouton d'une slide n'est pas un bloc : il ne suit pas le thème.
  if (buttonProps) return generics;
  return (
    <ThemeStyleGallery kind="button" classes={styles}>
      {generics}
    </ThemeStyleGallery>
  );
}

export function puckButtonStyleField(label = 'Style du bouton') {
  return {
    type: 'custom',
    label,
    /* L'aperçu voyage avec la galerie : c'est le premier endroit où on juge un
       style, et les deux lisent les mêmes props du bloc sélectionné. */
    render: () => (
      <>
        <ButtonPreview />
        <div className={styles.gallery}>
          <ButtonStylePicker />
        </div>
      </>
    ),
  };
}
